import { Outlet, Navigate } from "react-router";
import TwoFactorAuth from "./private_page/RestrictedPages/TwoFactorAuth";
import Restriction from "./private_page/RestrictedPages/Restriction";

const AllPermission = ({auth, currentUserData}) => {
  if (auth) {
    return currentUserData?.twoFA ?
      <TwoFactorAuth /> :
      currentUserData?.roleType === "user" ?
      <Outlet />
      : <Restriction />;
  } else {
    return <Navigate to="/login" />;
  }
};

const LoginPermission = ({auth}) => {
  if (!auth) {
    return <Outlet to="/login" />;
  } else {
    return <Navigate to="/home" />;
  }
};

export const Permission = {
  LoginPermission,
  AllPermission,
};
